'use client';
function CacheProvider({ children }) {
  return children;
}

export { CacheProvider };
